<!-- CP TEMPLATE -->
<div
    class="container-text-fluid"
    [class.link]="item.context === 'link' || item.context === 'applink'"
>
    <div class="preview-wrap">
        <div class="preview-loading-wrap">
            <div *ngIf="errorMsg">
                {{errorMsg}}
            </div>
            <div *ngIf="spinner && !content">
                <sync-spinner></sync-spinner>
            </div>
        </div>
        <br />
        <div
            id="preview-text-content"
            *ngIf="!spinner && content"
            class="preview-text-content"
            [ngClass]="{'unselectable': item &&  item.isReadOnly}"
        >
            {{content}}
        </div>
    </div>
</div>
<!-- /container -->
<!-- /CP TEMPLATE -->